import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center pa-4" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_item = _resolveComponent("v-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_item_group = _resolveComponent("v-item-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: $setup.activeDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.activeDialog) = $event)),
      transition: "dialog-bottom-transition",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Settings")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      "prepend-icon": "mdi-close",
                      onClick: $setup.closeSettings
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Close")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_item_group, {
                  modelValue: $setup.selectedTheme,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedTheme) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.themes, (t) => {
                              return _createVNode(_component_v_col, {
                                key: t.name,
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_item, { value: t }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_img, {
                                            onClick: ($event: any) => ($setup.toggleTheme(t)),
                                            src: t.img,
                                            style: {"max-height":"100px"}
                                          }, null, 8 /* PROPS */, ["onClick", "src"]),
                                          _createVNode(_component_v_card_title, { class: "d-none d-md-flex" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(t.name) + " ", 1 /* TEXT */),
                                              ($setup.selectedTheme.name === t.name)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (x)"))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            }), 64 /* STABLE_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}